/**
 * 加载外部的js文件
 * @param url 要加载的js的url地址
 *
 */
export const loadScript = (url, cb) => {
  let script = document.createElement("script");
  if (typeof cb === "function") {
    script.onload = function () {
      cb();
    };
  }
  script.src = url;
  document.head.appendChild(script);
};
